module.exports = __webpack_public_path__ + "static/img/price-2.7c5001c2.png";